import { UsersPage as Users } from '../pages';
import { WithRouteData } from '../render-routes';

export const UsersPage = () => {
  return <Users />;
};

export default WithRouteData(UsersPage);
